import React from 'react';
import { Link } from 'react-router-dom';
import type { BlogPost } from '../../types/blog';

interface BlogPostCardProps {
  post: BlogPost;
}

export default function BlogPostCard({ post }: BlogPostCardProps) {
  const [imageLoaded, setImageLoaded] = React.useState(false);

  return (
    <Link 
      to={`/blog/${post.slug}`}
      className="group block"
    >
      <div className="bg-white rounded-lg shadow-md overflow-hidden transition-shadow group-hover:shadow-lg">
        <div className="aspect-[16/9] overflow-hidden relative">
          <div className={`absolute inset-0 bg-gray-100 transition-opacity duration-300 ${imageLoaded ? 'opacity-0' : 'opacity-100'}`} />
          <img 
            src={post.image_url} 
            alt={post.title}
            onLoad={() => setImageLoaded(true)}
            className={`w-full h-full object-cover transition-transform duration-300 group-hover:scale-105 ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
          />
        </div>
        <div className="p-6">
          <h3 className="font-semibold text-lg mb-2 group-hover:text-primary-600 transition-colors">
            {post.title}
          </h3>
          <p className="text-gray-600 text-sm line-clamp-2">{post.excerpt}</p>
        </div>
      </div>
    </Link>
  );
}